import { c as _c } from "react/compiler-runtime";
import React, { useRef, useState } from 'react';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import CtaButton from 'components/essentials/Cta/CtaButton';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import FormikFirstErrorFieldFocusOnSubmit from 'components/essentials/FormikFirstErrorFieldFocusOnSubmit';
import { logError } from 'commons/logger';
import ValidationError from 'components/consumer/ValidationError';
import useSetZipCodeFromUser from 'global-state/zipCodeFromUser/useSetZipCodeFromUser';
import { ZIPCODE_ERROR_MESSAGES } from 'commons/constants';
import useUserLocationFromZipcode from 'hooks/useUserLocationFromZipcode';
import useIsZipCodeServiceable from 'hooks/useIsZipCodeServiceable';
import PDPAlertBar from '../PDP/PDPAlertBar';
const INITIAL_VALUES = {
  zipcode: ''
};
const validateZipcodeInput = inputs => {
  const errors = {};
  if (!inputs.zipcode.toString().trim()) {
    errors.zipcode = ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_EMPTY;
  } else if (!/^\d{5}(-\d{4})?$/.test(inputs.zipcode)) {
    errors.zipcode = ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_INVALID_FORMAT;
  }
  return errors;
};
const UpdateZipcodeForm = t0 => {
  const $ = _c(11);
  const {
    onUpdateSuccess
  } = t0;
  const zipInputRef = useRef();
  const [isZipServiceable, setIsZipServiceable] = useState(true);
  const setZipCodeFromUser = useSetZipCodeFromUser();
  const {
    refetch: getIsZipCodeServiceable
  } = useIsZipCodeServiceable();
  const {
    refetch: getVisitorLocationFromZipcode
  } = useUserLocationFromZipcode();
  const [nonServiceableZipError, setNonServiceableZipError] = useState("");
  let t1;
  if ($[0] !== getIsZipCodeServiceable || $[1] !== getVisitorLocationFromZipcode || $[2] !== onUpdateSuccess || $[3] !== setZipCodeFromUser) {
    t1 = async (t2, t3) => {
      const {
        zipcode
      } = t2;
      const {
        setFieldError,
        setSubmitting
      } = t3;
      setSubmitting(true);
      if (!zipcode) {
        setFieldError("zipcode", ZIPCODE_ERROR_MESSAGES.ZIPCODE_IS_EMPTY);
        return;
      }
      const trimmedZipCode = zipcode.trim();
      setZipCodeFromUser(trimmedZipCode);
      ;
      try {
        const {
          error: isZipCodeServiceableError,
          nonServiceableZipCodeError,
          isZipCodeServiceable: isServiceable
        } = await getIsZipCodeServiceable(trimmedZipCode);
        if (!isServiceable) {
          setIsZipServiceable(isServiceable);
          if (isZipCodeServiceableError) {
            setFieldError("zipcode", isZipCodeServiceableError);
          }
          if (nonServiceableZipCodeError) {
            setNonServiceableZipError(nonServiceableZipCodeError);
          }
          return;
        }
        const {
          errorMessage: getLocationErrorMessage
        } = await getVisitorLocationFromZipcode(trimmedZipCode);
        if (getLocationErrorMessage) {
          setFieldError("zipcode", getLocationErrorMessage);
          return;
        }
        onUpdateSuccess(isServiceable);
      } catch (t4) {
        const error = t4;
        logError(error);
        setFieldError("zipcode", ZIPCODE_ERROR_MESSAGES.UNEXPECTED_ERROR);
      }
    };
    $[0] = getIsZipCodeServiceable;
    $[1] = getVisitorLocationFromZipcode;
    $[2] = onUpdateSuccess;
    $[3] = setZipCodeFromUser;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== isZipServiceable || $[6] !== nonServiceableZipError) {
    t2 = t3 => {
      const {
        values,
        errors,
        touched,
        handleChange,
        handleSubmit,
        handleBlur,
        isSubmitting
      } = t3;
      return <form onSubmit={handleSubmit}><LabeledTextInput errorMessage={touched.zipcode && errors.zipcode ? errors.zipcode : null} id="zipcode" type="zipcode" name="zipcode" label="Zip code" onChange={handleChange} onBlur={handleBlur} autoComplete="zipcode" value={values.zipcode} data-xc="zipcode-field" ref={zipInputRef} autoFocus={true} /><CtaButton hasArrow={false} color="black" type="submit" styling="solid-button" block={true} isLoading={isSubmitting}>Update</CtaButton>{errors.formErrors && <ValidationError block={true}>{errors.formErrors}</ValidationError>}<FormikFirstErrorFieldFocusOnSubmit formFieldRefs={{
          zipcode: zipInputRef
        }} />{!isZipServiceable && <PDPAlertBar> {nonServiceableZipError}</PDPAlertBar>}</form>;
    };
    $[5] = isZipServiceable;
    $[6] = nonServiceableZipError;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <Formik initialValues={INITIAL_VALUES} validate={validateZipcodeInput} onSubmit={t1}>{t2}</Formik>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
UpdateZipcodeForm.propTypes = {
  onUpdateSuccess: PropTypes.func
};
export default UpdateZipcodeForm;